import * as types from '../types.js';

export default {

	html: `
		<form id="iqvia-report-form" class="form" autocomplete="off">
			<div class="title">Relatório IQVIA — Vendas e Devoluções</div>
			<div class="mtl">
				<label>Empresa
					<input id="company_id" list="iqvia-companies" required placeholder="Selecione a empresa">
					<datalist id="iqvia-companies"></datalist>
				</label>
			</div>
			<div class="mtl">
				<label>Data início
					<input id="date_from" type="text" required placeholder="dd/mm/aaaa">
				</label>
			</div>
			<div class="mtl">
				<label>Data fim (opcional)
					<input id="date_to" type="text" placeholder="dd/mm/aaaa">
				</label>
			</div>
			<div class="mtm">
				<button class='bn_Escape button'>Fechar</button>
				<button class='bn_Enter button'>Imprimir</button>
			</div>
		</form>
	`,

	form: {
		selector: '#iqvia-report-form',
		init(formset) {
			formset.form.eraseValues();
			formset.loadList('#iqvia-companies', 'companies', { labels: ['nick'], value: 'id' });
			Object.getPrototypeOf(this).init.call(this);
		},
	},

	fields: [
		{ properties: { selector: '#company_id' }, types: [types.datalist()] },
		{ properties: { selector: '#date_from' }, types: [types.date()] },
		{ properties: { selector: '#date_to' }, types: [types.date()] },
	]

};
